import { BrowserRouter } from 'react-router-dom';
import { reactOnCms } from 'common/js/react_on_cms';
import 'common/js/modal_controller/initialize_html_modals';
import { Provider } from 'react-redux';
import AbandonCartModal from 'components/abandon_cart_modal';
import AvailabilityQuickView from 'components/availability_quick_view';
import AvailabilitySearch from 'components/availability_search';
import CrmTracking from 'components/crm_tracking';
import SearchWidget from 'components/search_widget';
import store from 'redux/store';
import Logout from 'tenants/cccsyd/auth/logout';
import CartIcon from 'tenants/cccsyd/cart_icon';

reactOnCms.addWrapper({
  reactElement: BrowserRouter,
});

// Wrap content with Redux Provider
reactOnCms.addWrapper({
  reactElement: Provider,
  reactProps: { store },
});

reactOnCms.register({
  CartIcon,
  Logout,
  AvailabilityQuickView,
  AvailabilitySearch,
  CrmTracking,
  SearchWidget,
  AbandonCartModal,
});
